import { useState, useEffect, useRef } from 'react';
import Body from "../components/layout/Body";
import { 
    Box, 
    Typography, 
    TextField, 
    Button, 
    Divider, 
    CircularProgress,
    Alert,
    Snackbar,
    Paper,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../store/auth-context";
import useApiHook from "../hooks/useApiHook";

const COUNTRY_CODES = [
    { code: '+1', name: 'Stati Uniti / Canada' },
    { code: '+7', name: 'Russia / Kazakistan' },
    { code: '+20', name: 'Egitto' },
    { code: '+27', name: 'Sudafrica' },
    { code: '+30', name: 'Grecia' },
    { code: '+31', name: 'Paesi Bassi' },
    { code: '+32', name: 'Belgio' },
    { code: '+33', name: 'Francia' },
    { code: '+34', name: 'Spagna' },
    { code: '+36', name: 'Ungheria' },
    { code: '+39', name: 'Italia' },
    { code: '+40', name: 'Romania' },
    { code: '+41', name: 'Svizzera' },
    { code: '+43', name: 'Austria' },
    { code: '+44', name: 'Regno Unito' },
    { code: '+45', name: 'Danimarca' },
    { code: '+46', name: 'Svezia' },
    { code: '+47', name: 'Norvegia' },
    { code: '+48', name: 'Polonia' },
    { code: '+49', name: 'Germania' },
    { code: '+51', name: 'Perù' },
    { code: '+52', name: 'Messico' },
    { code: '+53', name: 'Cuba' },
    { code: '+54', name: 'Argentina' },
    { code: '+55', name: 'Brasile' },
    { code: '+56', name: 'Cile' },
    { code: '+57', name: 'Colombia' },
    { code: '+58', name: 'Venezuela' },
    { code: '+60', name: 'Malesia' },
    { code: '+61', name: 'Australia' },
    { code: '+62', name: 'Indonesia' },
    { code: '+63', name: 'Filippine' },
    { code: '+64', name: 'Nuova Zelanda' },
    { code: '+65', name: 'Singapore' },
    { code: '+66', name: 'Thailandia' },
    { code: '+81', name: 'Giappone' },
    { code: '+82', name: 'Corea del Sud' },
    { code: '+84', name: 'Vietnam' },
    { code: '+86', name: 'Cina' },
    { code: '+90', name: 'Turchia' },
    { code: '+91', name: 'India' },
    { code: '+92', name: 'Pakistan' },
    { code: '+93', name: 'Afghanistan' },
    { code: '+94', name: 'Sri Lanka' },
    { code: '+95', name: 'Myanmar' },
    { code: '+98', name: 'Iran' },
    { code: '+212', name: 'Marocco' },
    { code: '+213', name: 'Algeria' },
    { code: '+216', name: 'Tunisia' },
    { code: '+218', name: 'Libia' },
    { code: '+220', name: 'Gambia' },
    { code: '+234', name: 'Nigeria' },
    { code: '+351', name: 'Portogallo' },
    { code: '+352', name: 'Lussemburgo' },
    { code: '+353', name: 'Irlanda' },
    { code: '+354', name: 'Islanda' },
    { code: '+355', name: 'Albania' },
    { code: '+356', name: 'Malta' },
    { code: '+357', name: 'Cipro' },
    { code: '+358', name: 'Finlandia' },
    { code: '+359', name: 'Bulgaria' },
    { code: '+370', name: 'Lituania' },
    { code: '+371', name: 'Lettonia' },
    { code: '+372', name: 'Estonia' },
    { code: '+373', name: 'Moldavia' },
    { code: '+374', name: 'Armenia' },
    { code: '+375', name: 'Bielorussia' },
    { code: '+376', name: 'Andorra' },
    { code: '+377', name: 'Monaco' },
    { code: '+378', name: 'San Marino' },
    { code: '+380', name: 'Ucraina' },
    { code: '+381', name: 'Serbia' },
    { code: '+382', name: 'Montenegro' },
    { code: '+385', name: 'Croazia' },
    { code: '+386', name: 'Slovenia' },
    { code: '+387', name: 'Bosnia-Erzegovina' },
    { code: '+389', name: 'Macedonia del Nord' },
    { code: '+420', name: 'Repubblica Ceca' },
    { code: '+421', name: 'Slovacchia' },
    { code: '+423', name: 'Liechtenstein' },
    { code: '+886', name: 'Taiwan' },
    { code: '+962', name: 'Giordania' },
    { code: '+963', name: 'Siria' },
    { code: '+964', name: 'Iraq' },
    { code: '+965', name: 'Kuwait' },
    { code: '+966', name: 'Arabia Saudita' },
    { code: '+967', name: 'Yemen' },
    { code: '+968', name: 'Oman' },
    { code: '+970', name: 'Palestina' },
    { code: '+971', name: 'Emirati Arabi Uniti' },
    { code: '+972', name: 'Israele' },
    { code: '+973', name: 'Bahrain' },
    { code: '+974', name: 'Qatar' },
    { code: '+975', name: 'Bhutan' },
    { code: '+976', name: 'Mongolia' },
    { code: '+977', name: 'Nepal' },
];

const TITOLI = ['Dott.', 'Dott.ssa'];
const PROFESSIONI = ['Psicologo', 'Psicoterapeuta'];

const SchedaPsicologo = () => {
    const navigate = useNavigate();
    const authCtx = useAuth();
    const user = authCtx.user;
    const isLoading = authCtx.isLoading;
    const { response: apiResponse, makeRequest, error: apiError } = useApiHook();

    const [formData, setFormData] = useState({
        name: '',
        lastname: '',
        prefissoTelefono: '',
        numeroTelefono: '',
        titolo: '',
        professione: '',
        orientamentoPsicologico: ''
    });

    const [saving, setSaving] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const lastResponseRef = useRef(null);
    const lastErrorRef = useRef(null);

    useEffect(() => {
        if (!isLoading && !user) {
            navigate('/auth');
        }
    }, [isLoading, user, navigate]);

    useEffect(() => {
        if (user) {
            setFormData({
                name: user.name || '',
                lastname: user.lastname || '',
                prefissoTelefono: user.prefissoTelefono || '+39',
                numeroTelefono: user.numeroTelefono || '',
                titolo: user.titolo || '',
                professione: user.professione || '',
                orientamentoPsicologico: user.orientamentoPsicologico || ''
            });
        }
    }, [user]);

    useEffect(() => {
        if (apiResponse && apiResponse.state === 'success' && apiResponse !== lastResponseRef.current) {
            lastResponseRef.current = apiResponse;
            authCtx.updateUser(apiResponse.data.user);
            setSnackbar({
                open: true,
                message: 'Profilo aggiornato con successo!',
                severity: 'success'
            });
            setSaving(false);
        }
    }, [apiResponse]);

    useEffect(() => {
        if (apiError && apiError !== lastErrorRef.current) {
            lastErrorRef.current = apiError;
            setSnackbar({
                open: true,
                message: apiError.message || 'Errore durante il salvataggio',
                severity: 'error'
            });
            setSaving(false);
        }
    }, [apiError]);

    const handleClose = () => {
        navigate('/dashboard');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        await makeRequest('/auth/profile/update', 'post', formData);
    };

    const handleCloseSnackbar = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    if (isLoading || !user) {
        return (
            <Body mainElement={
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                    <CircularProgress />
                </Box>
            } />
        );
    }

    const mainContent = (
        <Box>
            <Box mb={3}>
                <Typography variant="h4" fontWeight="bold">
                    Scheda Psicologo
                </Typography>
                <Typography color="text.secondary" mt={1}>
                    Gestisci le informazioni professionali e i dati di contatto del tuo account.
                </Typography>
            </Box>

            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Paper elevation={0} sx={{ border: '1px solid #e0e0e0', p: 3 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography variant="h6">Dati account</Typography>
                        <Box sx={{
                            display: 'grid',
                            gap: { xs: 2, md: 3 },
                            gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' }
                        }}>
                            <TextField
                                label="Nome"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />

                            <TextField
                                label="Cognome"
                                name="lastname"
                                value={formData.lastname}
                                onChange={handleChange}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />

                            <TextField
                                label="Email"
                                value={user?.email || ''}
                                disabled
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={{ gridColumn: { xs: '1', md: 'span 2' } }}
                            />
                        </Box>
                    </Box>
                </Paper>

                <Paper elevation={0} sx={{ border: '1px solid #e0e0e0', p: 3 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography variant="h6">Dati professionali</Typography>
                        <Box sx={{
                            display: 'grid',
                            gap: { xs: 2, md: 3 },
                            gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' }
                        }}>
                            <Box sx={{
                                gridColumn: { xs: '1', md: 'span 2' },
                                display: 'flex',
                                gap: 2,
                                flexDirection: { xs: 'column', sm: 'row' }
                            }}>
                                <FormControl
                                    sx={{
                                        width: { xs: '100%', sm: '40%', md: '30%' }
                                    }}
                                >
                                    <InputLabel id="prefisso-label" shrink>
                                        Prefisso Telefono
                                    </InputLabel>
                                    <Select
                                        labelId="prefisso-label"
                                        name="prefissoTelefono"
                                        value={formData.prefissoTelefono}
                                        onChange={handleChange}
                                        label="Prefisso Telefono"
                                        notched
                                        sx={{
                                            '& .MuiSelect-select': {
                                                minHeight: '1.4375em'
                                            }
                                        }}
                                    >
                                        {COUNTRY_CODES.map((country) => (
                                            <MenuItem key={country.code} value={country.code}>
                                                {country.code} ({country.name})
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <TextField
                                    label="Numero Telefono"
                                    name="numeroTelefono"
                                    value={formData.numeroTelefono}
                                    onChange={handleChange}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    placeholder="es. 3331234567"
                                    sx={{ flex: 1 }}
                                />
                            </Box>

                            <FormControl fullWidth>
                                <InputLabel id="titolo-label" shrink>
                                    Titolo
                                </InputLabel>
                                <Select
                                    labelId="titolo-label"
                                    name="titolo"
                                    value={formData.titolo}
                                    onChange={handleChange}
                                    label="Titolo"
                                    displayEmpty
                                    notched
                                    sx={{
                                        '& .MuiSelect-select': {
                                            minHeight: '1.4375em'
                                        }
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>Seleziona titolo</em>
                                    </MenuItem>
                                    {TITOLI.map((titolo) => (
                                        <MenuItem key={titolo} value={titolo}>
                                            {titolo}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel id="professione-label" shrink>
                                    Professione
                                </InputLabel>
                                <Select
                                    labelId="professione-label"
                                    name="professione"
                                    value={formData.professione}
                                    onChange={handleChange}
                                    label="Professione"
                                    displayEmpty
                                    notched
                                    sx={{
                                        '& .MuiSelect-select': {
                                            minHeight: '1.4375em'
                                        }
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>Seleziona professione</em>
                                    </MenuItem>
                                    {PROFESSIONI.map((prof) => (
                                        <MenuItem key={prof} value={prof}>
                                            {prof}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <TextField
                                label="Orientamento Psicologico"
                                name="orientamentoPsicologico"
                                value={formData.orientamentoPsicologico}
                                onChange={handleChange}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                placeholder="es. Cognitivo-Comportamentale"
                                sx={{ gridColumn: { xs: '1', md: 'span 2' } }}
                            />
                        </Box>
                    </Box>
                </Paper>

                <Divider />

                <Box sx={{
                    display: 'flex',
                    justifyContent: { xs: 'stretch', md: 'flex-end' },
                    gap: 2,
                    flexDirection: { xs: 'column', sm: 'row' }
                }}>
                    <Button
                        type="button"
                        variant="outlined"
                        onClick={handleClose}
                    >
                        Annulla
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                        disabled={saving}
                        sx={{
                            minWidth: { xs: '100%', sm: '220px' },
                            minHeight: '48px'
                        }}
                    >
                        {saving ? 'Salvataggio...' : 'Salva modifiche'}
                    </Button>
                </Box>
            </Box>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert 
                    onClose={handleCloseSnackbar} 
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );

    return <Body mainElement={mainContent} />;
};

export default SchedaPsicologo;
